import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import React, { FC } from 'react'
import { useSelector } from 'react-redux'

import darkTheme from '../config/darkTheme'
import theme from '../config/theme'
import { getTheme } from '../store/ui'
interface Props {
  title: string
  icon: React.ReactNode
  onClick: () => void
}

const ServiceItem: FC<Props> = ({ title, icon, onClick }) => {
  const themeApp = useSelector(getTheme)
  const responsiveLoadingButton = {
    '&.MuiBox-root': {
      width: { xs: 1 / 4, sm: 1.75 / 4, md: 1.75 / 4, lg: 226 },
      display: 'flex',
      justifyContent: 'space-around',
      background: themeApp === 'dark' ? theme.palette.common.white : darkTheme.palette.common.white,
      maxWidth: { xs: 1 / 4, sm: 1.75 / 4, md: 1.75 / 4, lg: 226 },
      borderRadius: 2,
      // py: 0.5,
      // px: 1,
      boxShadow: '0 0 2px rgba(0,0,0,0.25)',
      // mx: 1,
      // flexWrap: 'nowrap',
      minWidth: 50,
      m: { xs: 0.5, sm: 0.5, md: 1, lg: 1 },
      cursor: 'pointer',
    },
  }
  const responsiveMuiTypography = {
    '&.MuiTypography-root': {
      fontSize: { xs: 10, sm: 15, md: 20, lg: 15 },
    },
  }

  return (
    <Box
      onClick={onClick}
      sx={responsiveLoadingButton}
      // sx={{
      //   display: 'flex',
      //   justifyContent: 'center',
      //   bgcolor: 'background.paper',
      //   maxWidth: 135,
      //   borderRadius: 2,
      //   py: 0.5,
      //   px: 1,
      //   boxShadow: '0 0 2px rgba(0,0,0,0.25)',
      //   mx: 1,
      //   width: 135,
      //   flexWrap: 'nowrap',
      //   minWidth: 100,
      //   m: 2,
      //   cursor: 'pointer',
      // }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          alignItems: 'center',
          flexWrap: 'nowrap',
          whiteSpace: 'nowrap',
        }}
      >
        <Box>{icon}</Box>
        <Typography sx={responsiveMuiTypography} variant='subtitle1'>
          {title}
        </Typography>
      </Box>
    </Box>
  )
}

export default ServiceItem
